module.exports = __webpack_public_path__ + "assets/4.1575b1de.png";